var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1960_2387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0674 12.1556C15.9757 12.1556 18.3334 9.80751 18.3334 6.91103C18.3334 4.01456 15.9757 1.6665 13.0674 1.6665C10.159 1.6665 7.80133 4.01456 7.80133 6.91103C7.80133 8.25266 8.41366 9.22838 8.41366 9.22838L2.04542 15.5706C1.75967 15.8552 1.35961 16.5951 2.04542 17.2781L2.78022 18.0099C3.06596 18.2539 3.78441 18.5954 4.37224 18.0099L5.22951 17.1562C6.08677 18.0099 7.0665 17.5221 7.4339 17.0342C8.04623 16.1804 7.31143 15.3267 7.31143 15.3267L7.55636 15.0827C8.73204 16.2536 9.76075 15.5706 10.1282 15.0827C10.7405 14.229 10.1282 13.3752 10.1282 13.3752C9.88322 12.8874 9.39339 12.8874 10.0057 12.2776L10.7405 11.5457C11.3284 12.0336 12.5367 12.1556 13.0674 12.1556Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9042 6.91152C14.9042 7.92192 14.0818 8.741 13.0672 8.741C12.0527 8.741 11.2302 7.92192 11.2302 6.91152C11.2302 5.90112 12.0527 5.08203 13.0672 5.08203C14.0818 5.08203 14.9042 5.90112 14.9042 6.91152Z",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1960_2387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.b9b2a09552eaf7c1809aca52601c3607.svg";
export { ForwardRef as ReactComponent };